export const subSections = {
    SEARCH: 'SEARCH',
    SWAP: 'SWAP',
    ALL: 'ALL',
    SEARCH_INTENDED: 'SEARCH-INTENDED',
    TODO: 'TO-DO', 
    EDIT_DIAGNOSTICS : 'EDIT-DIAGNOSTICS', 
    DETAILS: 'DETAILS',
    SEND_EMAIL: 'SEND-EMAIL',
    RECONCILIATION: 'RECONCILIATION',
    DONOR_CONNECT_CONFIRM: 'DONOR-CONNECT-CONFIRM',
    WAGE_AND_TRAVEL: 'WAGE-AND-TRAVEL',
    DONOR_INTAKE: 'DONOR-INTAKE',
    VOUCHER_HOLDERS: 'VOUCHER-HOLDERS',
    VOUCHER_HOLDER_EDIT: 'VOUCHER_HOLDER_EDIT',
    DONOR_SHIELD_DIRECT: 'DONOR-SHIELD-DIRECT',
    PROFILE: 'PROFILE',
    CONFIRM_ADDRESS: 'CONFIRM-ADDRESS',
    PWL_DETAILS: 'PWL-DETAILS',
    ADD: 'ADD',
    VOUCHER_PROGRAM: 'VOUCHER_PROGRAM'
};

export const donorProfileSections = {
    ADMIN: 'ADMIN',
    DONOR_DATA: 'DONOR-DATA',
    DONOR_ADDRESS: 'DONOR-ADDRESS',
    MEDICAL_DETAILS: 'MEDICAL-DETAILS',
    HLA_INFO: 'HLA-INFO',
    RECORDS: 'RECORDS',
    CT_SCAN: 'CT-SCAN',
    ACTIVITY: 'ACTIVITY',
    ADP: 'ADP',
    POST_TRANSPLANT: 'POST-TRANSPLANT',
    VOUCHERS: 'VOUCHERS',
    VOUCHER_ADD: 'VOUCHER-ADD',
    VOUCHER_EDIT: 'VOUCHER-EDIT'
}
